import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccesoService {

  desencriptarTOKEN() : any {
    let TOKEN = environment.secret_key;
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `${TOKEN}`);
    return headers;
  }
  desencriptarTOKENLOCAL() : any {
    let TOKEN2 = environment.secret_key;
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `${TOKEN2}`);
    return headers;
  }
}
